import Vue from 'vue'
import Router from 'vue-router'
import TheLogin from '@/views/TheLogin' //登录页面
import RetrievePassword from '@/views/RetrievePassword' //找回密码
import RegisterNewPassword from '@/views/RegisterNewPassword' // 找回密码 输入新密码
import TheRegister from '@/views/TheRegister' // 注册
import OrdinaryUsers from '@/views/OrdinaryUsers' // 普通用户展示
import BookingInformation from '@/views/BookingInformation' // 活动预定
Vue.use(Router)

export default new Router({
	routes: [{
		//登录页
		path: '/',
		name: 'Login',
		component: TheLogin
	}, {
		//找回密码
		path: '/RetrievePassword',
		name: '找回密码',
		component: RetrievePassword
	}, {
		//找回密码 输入新密码
		path: '/RegisterNewPassword',
		name: '找回密码1',
		component: RegisterNewPassword
	}, {
		//注册
		path: '/TheRegister',
		name: '注册',
		component: TheRegister
	}, {
		//普通用户
		path: '/OrdinaryUsers',
		name: '普通用户',
		component: OrdinaryUsers
	},{
		//活动预定
		path: '/BookingInformation',
		name: '活动预定',
		component: BookingInformation
	}, ]
})



// WEBPACK FOOTER //
// ./src/router/index.js